module.exports = {
  siteTitle: 'William Ekomobong',
  siteDescription: `Create your online curriculum in just a few minutes with this starter`,
  authorName: 'william',
  twitterUsername: 'komzy86',
  githubUsername: 'Komzy96',
  authorAvatar: '/images/about2.jpg',
  authorDescription: `I am Web Developer, passionate about what I do. I studied computer science at Federal University Lafia. <br />
  <br>Im currently working as an Intern at Elitepath.   
  So far i've Improved my skills in software Development and contributed to the software developnment team.<br />
  <br>I'm a frontend developenment and mainly work with <strong>Javascript, React (Js Framework),HTML and css.</strong>`,
  skills: [
    {
      name: 'HTML',
      level: 70
    },
    {
      name: 'CSS',
      level: 60
    },
    {
      name: 'Javascript',
      level: 50
    },
    {
      name: 'NodeJs',
      level: 20
    },
    {
      name: 'React',
      level: 40
    },
    {
      name: 'Git',
      level: 50
    }
  ],
  jobs: [
    {
      company: "Elithpath",
      begin: {
        month: 'Jan',
        year: '2019'
      },
      duration: null,
      occupation: "Intern",
      description: "Learning and contributing in the developnment of custom sofwares for clients."
  
    }, {
      company: "IMSUTH",
      begin: {
        month: 'jan',
        year: '2018'
      },
      duration: '1 yr e 5 mos',
      occupation: "Network Administrator",
      description: "Maintenance, (corrective and preventive), of  networking infrastructors for Hospital."
    }, {
      company: "Vestude Technologies",
      begin: {
        month: 'sep',
        year: '2017'
      },
      duration: ' 6 mos',
      occupation: "Support Technician",
      description: "Responsible for the implementation and parameterization of a hospital management system, training and customer support. Acting also in person in guaranteeing the success and good use of the tool."
  
    },
    /* ... */
  ],
  social: {
    twitter: "https://twitter.com/komzy86",
    linkedin: "https://www.linkedin.com/in/willie-william-b98a88ba",
    github: "https://github.com/komzy96",
    email: "komzy96@gmail.com"
  },
  siteUrl: 'https://santosfrancisco.github.io/gatsbystarter-cv',
  pathPrefix: '/gatsby-starter-cv', // Note: it must *not* have a trailing slash.
  siteCover: '/images/cover.jpeg',
  googleAnalyticsId: 'UA-131359385-1',
  background_color: '#ffffff',
  theme_color: '#25303B',
  display: 'minimal-ui',
  icon: 'src/assets/gatsby-icon.png',
  headerLinks: [
    {
      label: 'William Ekomobong',
      url: '/',
    }
  ]
}